module.exports = __webpack_public_path__ + "static/media/logo-blackatend.d1e2d01f.png";